import { Constants } from '../data/constants';

export const BASE_URL: string = window.origin;

export function getAPIBaseURL(apiVersion: number = 2): string {
  // TEMPORARY OVERRIDE: Force production backend for testing trial banner logic
  // TODO: Remove this when testing is complete
  // const forceProduction = true;

  // When testing is done, change to: const forceProduction = false;
  // Or remove the override completely and use: const env = getEnv();

  const env = getEnv();
  const baseUrl =
    env === 'prod'
      ? Constants.API_BASE_URLS.production
      : env === 'stage'
      ? Constants.API_BASE_URLS.stage
      : Constants.API_BASE_URLS.dev;
  return `${baseUrl}/api/v${apiVersion}`;
}

export function getSocketBaseURL(): string {
  // TEMPORARY OVERRIDE: Force production socket for testing
  // TODO: Remove this when testing is complete
  // const forceProduction = true;

  // When testing is done, change to: const forceProduction = false;
  // Or remove the override completely and use: const env = getEnv();

  const env = getEnv();
  return env === 'prod'
    ? Constants.SOCKET_BASE_URLS.production
    : env === 'stage'
    ? Constants.SOCKET_BASE_URLS.stage
    : Constants.SOCKET_BASE_URLS.dev;
}

export function getEnv(): string {
  const env = isStage() ? 'stage' : isProduction() ? 'prod' : 'dev';
  return env;
}

export function isLocalhost(): boolean {
  return BASE_URL.indexOf('localhost:3000') >= 0;
}

export function isProduction(): boolean {
  return BASE_URL.indexOf('app.practiceinterviews.com') >= 0;
}

export function isDev(): boolean {
  return (
    BASE_URL.indexOf('dev.practiceinterviews.com') >= 0 ||
    BASE_URL.indexOf('pi-web-dev-de9584c6bf48.herokuapp.com') >= 0
  );
}

export function isStage(): boolean {
  return (
    BASE_URL.indexOf('stage.practiceinterviews.com') >= 0 ||
    BASE_URL.indexOf('pi-web-stage-ce1e156956cf.herokuapp.com') >= 0 ||
    BASE_URL.indexOf('practice-interviews-web.vercel.app') >= 0 ||
    BASE_URL.indexOf('practice-interviews-landing.vercel.app') >= 0 ||
    BASE_URL.indexOf('practice-interviews-470vj9mjb-fractal-labs.vercel.app') >=
      0
  );
}

export function isSafari(): boolean {
  const ua = navigator.userAgent;
  return ua.includes('Safari') && !ua.includes('Chrome');
}

export function isChrome(): boolean {
  const userAgentString = navigator.userAgent;
  return userAgentString.indexOf('Chrome') > -1;
}

export function isFirefox(): boolean {
  const userAgentString = navigator.userAgent;
  return userAgentString.indexOf('Firefox') > -1;
}
